module.exports = __webpack_public_path__ + "files/1c94ec6d3a4473f28e22f8e324a9c2bb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lato-italic-webfont.svg
 ** module id = 928
 ** module chunks = 0
 **/